module.exports = __webpack_public_path__ + "static/media/budget-header-icon.571f87d6.svg";